import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page page3"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["src"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["src"];
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];

// 引入图片
import 产品观 from '@/assets/v2/page3/产品观.webp';
import 返回首页 from '@/assets/v2/page3/返回首页.webp';
import 图片 from '@/assets/v2/page3/图片.webp';
import SpaceConcept from '@/assets/v2/page3/文字/SpaceConcept.webp';
import word2 from '@/assets/v2/page3/文字/word2.webp';
import word3 from '@/assets/v2/page3/文字/word3.webp';
import word4 from '@/assets/v2/page3/文字/word4.webp';
import xingzhuang from '@/assets/v2/page3/文字/xingzhuang.webp';
export default {
  __name: 'Page3',
  emits: ['goHome'],
  setup(__props, {
    emit: __emit
  }) {
    // case 2
    const emit = __emit;
    const gohome = () => {
      emit('goHome');
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, [_createElementVNode("img", {
        src: _unref(产品观),
        alt: "产品观",
        class: "产品观",
        loading: "lazy"
      }, null, 8, _hoisted_2), _createElementVNode("img", {
        src: _unref(返回首页),
        alt: "返回首页",
        class: "gohomeImage",
        onClick: gohome,
        loading: "lazy"
      }, null, 8, _hoisted_3), _createElementVNode("img", {
        src: _unref(SpaceConcept),
        alt: "SpaceConcept",
        class: "SpaceConcept",
        loading: "lazy"
      }, null, 8, _hoisted_4), _createElementVNode("img", {
        src: _unref(xingzhuang),
        alt: "xingzhuang",
        class: "xingzhuang",
        loading: "lazy"
      }, null, 8, _hoisted_5), _createElementVNode("img", {
        src: _unref(word2),
        alt: "word2",
        class: "word2",
        loading: "lazy"
      }, null, 8, _hoisted_6), _createElementVNode("img", {
        src: _unref(word3),
        alt: "word3",
        class: "word3",
        loading: "lazy"
      }, null, 8, _hoisted_7), _createElementVNode("img", {
        src: _unref(word4),
        alt: "word4",
        class: "word4",
        loading: "lazy"
      }, null, 8, _hoisted_8), _createElementVNode("img", {
        src: _unref(图片),
        alt: "图片",
        class: "图片",
        loading: "lazy"
      }, null, 8, _hoisted_9)]);
    };
  }
};